import { useParams } from 'react-router';
import UnAuthorizedMessage from '@/components/Permission/UnauthorizedMessage';
import ErrorCard from '@/components/UI/ErrorCard';
import { getFormConfigByTemplateCode } from '@/features/ApplicationForm/FormConfig/resolveFormConfig';
import { useApplicationForm, useApplications } from '@/hooks/ReactQueryHooks/useApplicationFromQuery';
import { usePermission } from '@/hooks/usePermission';
import { EPermission } from '@/types/Permission';
import { ApplicationNav } from '../ApplicationNav';

export const ApplicationFormDashboard = () => {
  const { applicationFormId } = useParams<string>();
  const { hasPermission } = usePermission();

  const fetchApplicationForm = useApplicationForm({
    formId: applicationFormId!,
  });
  const applicationForm = fetchApplicationForm?.data?.data;

  const applicationFromConfig = getFormConfigByTemplateCode(applicationForm?.templateCode);
  const DashboardComponent = applicationFromConfig?.applicationDashboardComponent;

  const fetchApplications = useApplications({
    formId: applicationFormId!,
    params: { perPage: 500 },
  });
  const data = fetchApplications?.data;

  if (!hasPermission([EPermission.READ_APPLICATION_FORM_DASHBOARD])) {
    return <UnAuthorizedMessage title='Unauthorized' message='You do not have permission to view this application form dashboard.' />;
  }

  const isLoading = fetchApplicationForm.isLoading || fetchApplications.isLoading;

  return (
    <>
      <ApplicationNav />
      <div className='flex justify-center'>
        {isLoading && <h2>Loading...</h2>}
        {fetchApplicationForm.isError && (
          <ErrorCard
            errorMsg='Oops! Something went wrong. We are trying to fix it as soon as possible. Please visit us again later.'
            errorTitle='Error'
          />
        )}
        {!isLoading && !fetchApplicationForm.isError && fetchApplications.isError && (
          <ErrorCard
            errorMsg='Oops! Something went wrong. We are trying to fix it as soon as possible. Please visit us again later.'
            errorTitle='Error'
          />
        )}
        {!isLoading && !fetchApplicationForm.isError && !fetchApplications.isError && data && !DashboardComponent && (
          <div className='flex items-center h-screen/2 w-full'>
            <ErrorCard
              errorMsg={
                applicationForm?.templateCode
                  ? `No dashboard is configured for form code "${applicationForm.templateCode}". Update the form's Form Code in settings if this form should use a known template (for example, gmf-dev-pipe for the GMF Developer Pipeline).`
                  : 'Oops! This dashboard is currently under construction. Please check back soon.'
              }
              errorTitle='Dashboard Under Construction'
            />
          </div>
        )}
      </div>
      {!isLoading && !fetchApplicationForm.isError && !fetchApplications.isError && data && DashboardComponent && (
        <DashboardComponent data={data} />
      )}
    </>
  );
};
